
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');


const Ticketmailview = (props) => {
    
    const handleClick = (e) => {
        e.stopPropagation();
        //console.log("Props Routmap ", props);
        props.agGridReact.props.gridOptions.context.componentParent.onShowTicketSentEmail(props);
    };

    return (
        <div>
			<button title="Ticket Mails" onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-envelope f20"></i> </button>
       
        </div>
    );
};

export default Ticketmailview;
